<template>
  <!-- Debug outputs -->
  <v-card
    v-if="_showDebug"
    class="debug-console"
  >
    <v-card-title>
      <div
        class="d-flex flex-column"
      >
        <div
          class="debug-card-title"
        >
          <div class="float-inline-start">
            Debug Info
          </div>
        
          <!-- <div /> -->
          <div class="debug-actions d-flex">
            <button
              icon
              class="debug-toggle-expand"
              title="Clear Console"
              @click="clearConsole"
            >
              <v-icon size="small">
                mdi-delete-outline
              </v-icon>
            </button>
          </div>
          <div class="debug-toggle-expand">
            <v-icon @click="toggleDebugExpansion()">
              {{ debugExpanded ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
            </v-icon>
          </div>
        </div>
      </div>
    </v-card-title>
   
    <v-expand-transition>
      <v-card-text
        v-if="debugExpanded"
        ref="debugConsoleBody"
        class="debug-console-body"
      >
        <ul>
          <li
            v-for="(debugItem, index) in debugMessages"
            :key="index"
            class="debug-message"
            :class="debugItem.messageType || DEBUG_MESSAGE_TYPES.INFORMATION"
          >
            <span
              v-if="debugItem.date"
              class="debug-date"
              :class="'debug-' + (debugItem.messageType || DEBUG_MESSAGE_TYPES.INFORMATION)"
            >
              [{{ debugItem.messageType?.toUpperCase() ?? '' }}] - [ {{ debugItem.date }} ] -
            </span>
            <span
              v-if="debugItem.data"
              :style="{ 'white-space': debugItem.preserveBreaks ? 'pre-line' : 'normal' }"
            >
              <!-- If it's a string, then just display that for now. -->
              <span v-if="typeof debugItem.data === 'string'">
                {{ debugItem.data }}

              </span>
              <span v-else>
                <!-- Main Message -->
                <div class="debug-section">
                  <strong>Message:</strong> {{ debugItem.data.message }}
                </div>

                <!-- HTTP Status -->
                <div
                  v-if="debugItem.data.httpStatus"
                  class="debug-section"
                >
                  <strong>HTTP Status:</strong> {{ debugItem.data.httpStatus }}
                </div>

                <!-- Diagnostics -->
                <div
                  v-if="debugItem.data.diagnostics"
                  class="debug-section"
                >
                  <strong>Diagnostics:</strong> {{ debugItem.data.diagnostics }}
                </div>

                <!-- URL Called -->
                <div
                  v-if="debugItem.data.urlCalled"
                  class="debug-section"
                >
                  <strong>URL Called:</strong>
                  <a
                    :href="debugItem.data.urlCalled"
                    target="_blank"
                  >{{ debugItem.data.urlCalled
                  }}</a>
                </div>

                <!-- Errors Array -->
                <div
                  v-if="debugItem.data.errors && debugItem.data.errors.length"
                  class="debug-section"
                >
                  <strong>Errors:</strong>
                  <ul>
                    <li
                      v-for="(error, i) in debugItem.data.errors"
                      :key="i"
                      :class="['error-item', error.severity]"
                    >
                      <div :class="`debug-${error.severity}`"><strong>[{{ error?.severity ?? ''
                      }}]:</strong> {{ error.message }}</div>
                      <div class=" ps-2"><strong>Diagnostics:</strong> {{ error.diagnostics }}
                      </div>
                    </li>
                  </ul>
                </div>
              </span>

            </span>
            <span v-else-if="typeof debugItem === 'string'">
              {{ debugItem }}
            </span>
          </li>
          <!-- The last list item is there in order to scroll to this element when we need to scroll to the bottom.-->
          <li ref="lastListItem" />
        </ul>
      </v-card-text>
    </v-expand-transition>
  </v-card>
</template>
<script>
import { DEBUG_MESSAGE_TYPES, PROJECT_VERSION, BUILD_NUMBER } from '../constants'
import packageInfo from '../../package.json'
import { useDebugStore } from '@/store/debugStore';
export default {
    name: 'DebugConsole',
    data() {
        return {
            debugExpanded: false,
            // debugMessages: [],
            frontendVersion: packageInfo.version,
            environment: process.env.NODE_ENV,
            DEBUG_MESSAGE_TYPES,
            debugStore: useDebugStore(),

        }
    },
    computed: {
        debugMessages() {
        return this.debugStore.debugMessages
    },
        _showDebug() {
          return true;
        },
    },
    watch: {
        debugMessages: {
            handler() {
                this.$nextTick( () => {
                this.scrollToBottom()
            } )
            },
            deep: true,
        },
    },
    created() {
        this.debugStore.debugMessages = this.debugMessages
    },
    mounted() {
        this.debugMessages = this.debugStore.debugMessages
        this.addDebugMessages( `Environment: ${this.environment}`, DEBUG_MESSAGE_TYPES.DEBUG )
        this.addDebugMessages( `Project version ${PROJECT_VERSION} | Build: ${BUILD_NUMBER}`, DEBUG_MESSAGE_TYPES.DEBUG )
        this.addDebugMessages( `Frontend version ${this.frontendVersion}`, DEBUG_MESSAGE_TYPES.DEBUG )

    },
    methods: {
        addDebugMessages( data, messageType = DEBUG_MESSAGE_TYPES.INFORMATION, preserveBreaks = false ) {
            const date = new Date().toLocaleString( 'en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            } )
            this.debugMessages.push( { date, data, messageType, preserveBreaks } );
        },
        scrollToBottom() {
            this.$refs.lastListItem?.scrollIntoView( { behavior: 'smooth' } );
        },

        toggleDebugExpansion() {
            this.debugExpanded = !this.debugExpanded
            if ( this.debugExpanded ) {
                this.scrollToBottom()
            }
        },
        clearConsole() {
            this.debugStore.clearDebugMessages()
        }
    }

}
</script>
<style scoped>
/* Debug Card container stylings */
.debug-console {
  position: fixed;
  bottom: 20px;
  /* right: 20px; */
  /* width: 400px; */
  width: 100%;
  max-height: 300px;
  background: rgba(0, 0, 0, 0.85);
  color: #00ff00;
  font-family: 'Consolas', monospace;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 255, 0, 0.2);
  z-index: 9999;
}

.debug-card-title {
  position: sticky;
  top: 0;
  background: inherit;
  z-index: 1;
  display: flex;
  justify-content: space-between;
}

.debug-console-body {
  max-height: 15em;
  overflow-y: scroll;
  scroll-behavior: smooth;
  /* scrollbar-width: thin; */
  scrollbar-color: #4CAF50 rgba(0, 0, 0, 0.85);
}

.debug-message {
  margin: 5px 0;
  font-size: 14px;
  border-bottom: 1px solid rgba(0, 255, 0, 0.2);
  padding-bottom: 5px;
  color: white;
}

.debug-date {
  color: #4CAF50;
  font-weight: bold;
}

.debug-warning {
  color: #ff9800;
}

.debug-success {
  color: #4CAF50;
}

.debug-error, .debug-fatal {
  color: #f44336;
}

.debug-information {
  color: #2196F3;
}

.debug-debug {
  color: #9c27b0;
}

.debug-message-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.debug-time {
  color: #2196F3;
  font-style: italic;
}

.debug-toggle-expand {
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  float: inline-end;
 padding-inline: 1em;
}

.debug-toggle-expand:hover {
  /* background-color: rgba(0, 0, 0, 0.85); */
  transform: scale(1.4);
}

.debug-toggle-expand:active {
  background-color: rgba(0, 0, 0, 0.2);
  transform: scale(0.95);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);
}
</style>